import { render, staticRenderFns } from "./Welcome.vue?vue&type=template&id=5a03a244&"
var script = {}
import style0 from "./Welcome.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports